// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Sibling imports
const SMSModal = require('./component-dumb')
const smsModalActions = require('./actions')

function mapStateToProps(state) {
  const { smsModal } = state
  const headingSelector = createSelector(
    state => state.smsModal,
    smsModal => {
      if (smsModal.isSubmitFailed) {
        return 'Sorry, we could not send the SMS.'
      }
      if (smsModal.isSubmitSuccessful) {
        return 'SMS sent.'
      }
      return 'Get the Mix App'
    }
  )
  const subheadingSelector = createSelector(
    state => state.smsModal,
    smsModal => {
      if (smsModal.isSubmitFailed) {
        return 'Please contact support@mix.com.'
      }
      if (smsModal.isSubmitSuccessful) {
        return 'Go check your phone!'
      }
      return 'Enter your phone number so we can send you a link to download Mix'
    }
  )
  if (!smsModal){
    return { isVisible: false }
  }
  return {
    // Flags
    isSubmitFailed: smsModal.isSubmitFailed,
    isSubmitSuccessful: smsModal.isSubmitSuccessful,
    isVisible: true,
    // Values
    heading: headingSelector(state),
    subheading: subheadingSelector(state)
  }
}

const mapDispatchToProps = {
  onDismiss: smsModalActions.hide,
  onSubmitError: smsModalActions.showSubmitError,
  onSubmitSuccess: smsModalActions.showSubmitSuccess
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      SMSModal
    )
  )
)
